// extracted by mini-css-extract-plugin
module.exports = {"postMessage":"styles_postMessage__1g7Tn","attachmentIcon":"styles_attachmentIcon__3edvd","attachmentInput":"styles_attachmentInput__iG_TA"};